import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/provide/auth.service';
import { CommonService } from 'src/app/provide/common.service';

@Component({
    selector: 'app-customer-deals-on-product-list',
    templateUrl: './customer-deals-on-product-list.component.html',
    styleUrls: ['./customer-deals-on-product-list.component.scss'],
    standalone: false
})
export class CustomerDealsOnProductListComponent implements OnInit {
  serviceName: any;
  serviceDetail: any;
  _id: any;
  dealImg: any;
  currentPage: any = 1;
  latitude: number;
  longitude: number;
  pageSize = 15;
  totalItems: any;
  totalCounts: any;
  loggedInUserType: any;
  headingName:any ='DEALS ON PRODUCTS'
  linkerRouteItems:any =[
    { name:'Home',route: '/home'},
    {name:'Deals On Products',route:'/customer-product-deal-list'}
  ]
  
  // Default location coordinates (Delhi, India) - used when geolocation is denied
  private readonly DEFAULT_LATITUDE = 28.6139;
  private readonly DEFAULT_LONGITUDE = 77.2090;
  private locationFetched: boolean = false;

  constructor(
    public commonService: CommonService,
    public authService: AuthService,
    public activated: ActivatedRoute,
    public router: Router
  ) {
    this.activated.queryParams.subscribe((res: any) => {
      this._id = res._id;
    });
  }

  ngOnInit(): void {
    this.authService.loggedInUserType.subscribe((res: any) => {
      this.loggedInUserType = res;
    });
    this.loggedInUserType = this.authService.checkUserTypeLoggedIn();
    
    // Initialize with default coordinates
    this.latitude = this.DEFAULT_LATITUDE;
    this.longitude = this.DEFAULT_LONGITUDE;
    
    // Try to get user's location, fallback to default if denied/error
    this.getLocation();
  }

  /**
   * Get user's current location with proper error handling
   * Falls back to default location if geolocation is denied or fails
   */
  getLocation(): void {
    if (!navigator.geolocation) {
      // Geolocation not supported, use default location
      console.log('Geolocation is not supported by this browser. Using default location.');
      this.loadDealsWithLocation();
      return;
    }

    // Set timeout for geolocation request (10 seconds)
    const options = {
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 0
    };

    navigator.geolocation.getCurrentPosition(
      (position: GeolocationPosition) => {
        // Success: Use user's actual location
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        console.log('Location obtained:', this.latitude, this.longitude);
        
        // Save to localStorage for future use
        try {
          localStorage.setItem('location', JSON.stringify({ 
            lng: this.longitude, 
            lat: this.latitude 
          }));
        } catch (e) {
          console.warn('Could not save location to localStorage:', e);
        }
        
        this.loadDealsWithLocation();
      },
      (error: GeolocationPositionError) => {
        // Error: Use default location
        console.log('Geolocation error:', error.message);
        
        // Check if we have saved location in localStorage
        try {
          const savedLocation = localStorage.getItem('location');
          if (savedLocation) {
            const location = JSON.parse(savedLocation);
            if (location.lat && location.lng) {
              this.latitude = location.lat;
              this.longitude = location.lng;
              console.log('Using saved location:', this.latitude, this.longitude);
              this.loadDealsWithLocation();
              return;
            }
          }
        } catch (e) {
          console.warn('Could not read saved location:', e);
        }
        
        // Fallback to default location
        console.log('Using default location:', this.DEFAULT_LATITUDE, this.DEFAULT_LONGITUDE);
        this.latitude = this.DEFAULT_LATITUDE;
        this.longitude = this.DEFAULT_LONGITUDE;
        this.loadDealsWithLocation();
      },
      options
    );
  }

  /**
   * Load deals with current location coordinates
   */
  private loadDealsWithLocation(): void {
    // Prevent multiple simultaneous calls
    if (this.locationFetched) {
      return;
    }
    this.locationFetched = true;
    this.serviceOrderList();
  }
  
  user: any;
  isLoading: boolean = false;
  
  /**
   * Fetch deals list from API with proper error handling
   */
  serviceOrderList(): void {
    // Ensure we have valid coordinates
    if (!this.latitude || !this.longitude) {
      console.error('Invalid coordinates. Using default location.');
      this.latitude = this.DEFAULT_LATITUDE;
      this.longitude = this.DEFAULT_LONGITUDE;
    }

    const url = `deal/listDealByLocation`;
    
    // Determine userType based on logged-in user type
    // Retailers see wholesaler deals, customers/guests see retailer deals
    if (this.loggedInUserType === 'RETAILER') {
    this.user = 'WHOLE_SALER';
    } else {
      // For CUSTOMER or not logged in, show RETAILER deals
      this.user = 'RETAILER';
    }

    const data = {
      dealType: 'PRODUCT',
      userType: this.user,
      lng: this.longitude,
      lat: this.latitude,
      page: this.currentPage,
      limit: this.pageSize,
      search: this.serviceName || '',
    };

    // Remove empty search if not provided
    if (!data.search) {
      delete data.search;
    }

    this.isLoading = true;
    this.commonService.showSpinner();

    const authFlag = this.commonService.isLoggedIn() ? 1 : 0;
    
    this.commonService.postApi(url, data, authFlag).subscribe(
      (res: any) => {
        this.commonService.hideSpinner();
        this.isLoading = false;
        
        if (res && res['responseCode'] == 200) {
          // Clear existing timers
          if (this.timerInterval) {
            this.timerInterval.forEach((interval: any) => {
              if (interval) clearInterval(interval);
            });
            this.countDown = [];
          }

          // Set service details
          const rawDeals = res.result?.docs || [];
          
          // Normalize deal data to ensure thumbnail is always present for deals-card component
          this.serviceDetail = rawDeals.map((deal: any) => {
            // Create a normalized deal object
            const normalizedDeal = { ...deal };
            
            // Populate thumbnail from various possible image fields
            if (!normalizedDeal.thumbnail) {
              if (deal.dealImage && Array.isArray(deal.dealImage) && deal.dealImage.length > 0) {
                normalizedDeal.thumbnail = deal.dealImage[0];
              } else if (deal.productId && Array.isArray(deal.productId) && deal.productId.length > 0 && deal.productId[0].thumbnail) {
                normalizedDeal.thumbnail = deal.productId[0].thumbnail;
              } else if (deal.productImage && Array.isArray(deal.productImage) && deal.productImage.length > 0) {
                normalizedDeal.thumbnail = deal.productImage[0];
              } else if (deal.images && Array.isArray(deal.images) && deal.images.length > 0) {
                normalizedDeal.thumbnail = deal.images[0];
              }
            }
            
            return normalizedDeal;
          });
          
          this.totalItems = res.result?.totalPages || 0;
          this.totalCounts = res.result?.count || 0;

          // Update loading state based on results
          if (!this.serviceDetail.length) {
            this.isLoading = true;
          }

          // Initialize countdown timers for each deal
          for (let index = 0; index < this.serviceDetail.length; index++) {
            if (this.serviceDetail[index]['dealEndTime']) {
              this.getCoundown(this.serviceDetail[index]['dealEndTime'], index);
            }
          }
        } else {
          // API returned error response
          this.serviceDetail = [];
          this.isLoading = true;
          const errorMsg = res?.responseMessage || 'Failed to load deals. Please try again.';
          this.commonService.errorToast(errorMsg);
        }
      },
      (err: any) => {
        this.commonService.hideSpinner();
        this.isLoading = true;
        this.serviceDetail = [];
        
        // Handle different error scenarios
        if (err?.status === 404) {
          console.error('API endpoint not found (404). Please check the API URL.');
          this.commonService.errorToast('Service temporarily unavailable. Please try again later.');
        } else if (err?.status === 0) {
          console.error('Network error. Please check your internet connection.');
          this.commonService.errorToast('Network error. Please check your internet connection.');
        } else if (err?.responseCode == 409) {
          this.commonService.errorToast(err.responseMessage || 'An error occurred.');
        } else {
          const errorMsg = err?.responseMessage || err?.message || 'Failed to load deals. Please try again.';
          console.error('API Error:', err);
          this.commonService.errorToast(errorMsg);
        }
      }
    );
  }
  pagination(event: number): void {
    this.currentPage = event;
    this.locationFetched = false; // Allow reload with same location
    this.serviceOrderList();
  }
  getPrice(e: any) {
    return this.commonService.getPrice(e)
  }

  // timer

  myTimer() {}
  // getDealDescription
  countDown: any = [];
  timerInterval: any = [];
  new: any;
  getCoundown(date: Date, i: number) {
    var countDownDate = new Date(date).getTime();
    let me = this;
    // Update the count down every 1 second

    this.timerInterval[i] = setInterval(() => {
      if (true) {
        // Get today's date and time
        let now = new Date().getTime();

        // Find the distance between now and the count down date
        let distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        let days = Math.floor(distance / (1000 * 60 * 60 * 24));
        let hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Output the result in an element with id="demo"
        me.countDown[i] =
        days + 'D:' + hours + 'H:' + minutes + 'M:' + seconds + 'S';        // If the count down is over, write some text
        if (distance < 0) {
          clearInterval(me.timerInterval);
          me.countDown[i] = 'EXPIRED';
        }
        // me.new = me.countDown[i]
      }

      // me.countDown[i] = mm
    }, 1000);
  }
  navigateToViewProduct(_id) {
    this.router.navigate(['/customer-product-view'], {
      queryParams: { _id: _id },
    });
  }
  length(n){
    return new Array(n)
  }
}
